import { render } from "./ModeratorsList.vue?vue&type=template&id=55b1b360"
import script from "./ModeratorsList.vue?vue&type=script&lang=js"
export * from "./ModeratorsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__